<div class="bpx-dialog">
  <h2 mat-dialog-title>Expired {{ data.lotTypeLabel }} Lot</h2>
  <mat-dialog-content>
    {{ data.lotTypeLabel }} lot <strong>{{ data.lotNumber }}</strong> expired on <strong>{{ data.expirationDate }}</strong>.
    Do you want to proceed with this expired lot?
  </mat-dialog-content>
  <mat-dialog-actions>
    <button matRipple class="bpx-btn bpx-btn--primary" (click)="confirm()">Confirm</button>
    <button matRipple class="bpx-btn" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
